import PropTypes from 'prop-types';

export const auditDataShape = PropTypes.shape({
  box_number: PropTypes.number,
  lpn: PropTypes.string,
  status: PropTypes.string,
  timestamp: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      reason: PropTypes.string,
      images: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
});

export default auditDataShape;
